import { render, staticRenderFns } from "./zMessage.vue?vue&type=template&id=1dae833d&scoped=true"
import script from "./zMessage.vue?vue&type=script&lang=js"
export * from "./zMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae833d",
  null
  
)

export default component.exports